import {createContext} from 'react';

const CallContext = createContext({connection : {}});
export default CallContext;